import reaInfADI from '@/sui/data/sheets/edit/cfg/reaInfADI'
import patient from '@/sui/data/sheets/edit/patient'
import bact from '@/sui/data/sheets/edit/bact'
import catheter from '@/sui/data/sheets/edit/catheter'
import intub from '@/sui/data/sheets/edit/intub'
import micro from '@/sui/data/microOrgs'
import multi from '@/sui/data/sheets/edit/multi'

import {
  fromField,
  bactDistribution,
  pneuDistribution,
  moDistribution,
  locDistribution,
  igsGroups
} from '@/sui/data/caracteristics/tools'

function reaInfKtDistribution (e) {
  const type = reaInfADI.catheterType.v3.config.values.find(
    v => v.code === e
  ).value

  return [
    { f: `kt_${e}_insertionSite`, t: `${type}`, h: true },
    fromField(`kt_${e}_insertionSite`, bact.insertionSite.full, 9),
    { f: `kt_${e}_lapse`, t: `Durée de cathétérisme`, minimizeDecimalScale: true },
    fromField(`kt_${e}_removed`, catheter.removed, 9),
    fromField(`kt_${e}_laboratory`, catheter.labo.v2, 9),
    fromField(`kt_${e}_isColIlcBlc`, reaInfADI.isColIlcBlc, 9),
    {
      f: `kt_${e}_lipids`,
      t: `${type} : Colonisations, ILC et BLC`,
      h: true
    },
    fromField(`kt_${e}_lipids`, bact.lipids.v3, 9),
    {
      f: `kt_${e}_origin`,
      t: `${type} : Pour les BLC`,
      h: true
    },
    {
      f: `kt_${e}_origin`,
      t: 'Origine',
      v: bact.bactOrigin.v2.config.values
    },
    fromField(`kt_${e}_divDiag`, bact.divDiag.v2, 9),
    {
      f: `kt_${e}_clinicalSigns`,
      t: `${type} : Pour les BLC avec critère BLC 5`,
      h: true
    },
    fromField(`kt_${e}_clinicalSigns`, bact.clinicalSigns, 9),
    fromField(`kt_${e}_bioSigns`, bact.bioSigns, 9),
    fromField(`kt_${e}_adaptedAntibio`, bact.adaptedAntibio, 9),
    fromField(`kt_${e}_twoHemocs`, bact.twoHemocs, 9),
    {
      f: `kt_${e}_previousManip`,
      t: `${type} : Pour les BLC associées à une CCI, un PICC ou un MIDline avec prolongateur (C2, C4 et C8)`,
      h: true
    },
    fromField(`kt_${e}_previousManip`, bact.previousManip),
    fromField(`kt_${e}_previousManipType`, bact.previousManipType.v2),
    {
      f: `kt_${e}_manipEpisodLapse`,
      t: `Délai entre la date de l'épisode et la date de manipulation`,
      minimizeDecimalScale: true
    }
  ]
}

export default function (estb, year, complete) {
  return [
    ...locDistribution('', 'patients', { estb: estb, year: year }),
    {
      title: 'Caractéristiques des patients',
      key: 'pat',
      list: [
        { f: `agey`, t: 'Âge (en années)', minimizeDecimalScale: true },
        fromField(`sex`, patient.sex, 9),
        fromField(`origin`, patient.patientOrigin.v3, 9),
        fromField(`immuno`, patient.immuno, 9),
        fromField(`cancer`, patient.cancer, 9),
        fromField(`trauma`, patient.trauma, 9),
        fromField(`diagnosis`, patient.diagnosis, 9),
        fromField(`antibio`, patient.antibio, 9),
        fromField(`bmi`, patient.bmi),
        fromField(`portageBmrBhre`, patient.portageBmrBhre, 9),
        {
          f: 'bmrMO',
          t: `BMR / BHRe`,
          v: micro.bmrBhre.v2
        },
        fromField(`dead`, patient.dead, 9),
        fromField('covidStatus', multi.covidStatus.exit, 9),
        fromField(`ecmo`, intub.ecmo),
        fromField(`intubated`, intub.intubated.std),
        fromField(`reintubated`, intub.reintubated.std),
        { f: `itbLapse`, t: `Durée d'intubation`, minimizeDecimalScale: true },
        { f: `stayLapse`, t: `Durée de séjour`, minimizeDecimalScale: true },
        fromField(`urinary`, reaInfADI.urinary, 9),

        { f: `cribII`, t: 'Nouveaux-nés', h: true },
        fromField(`cribII`, patient.cribII.std),
        { f: `pimII`, t: 'Enfants', h: true },
        fromField(`pimII`, patient.pimII.std),
        { f: `igsII`, t: 'Adultes', h: true },
        fromField(`igsII`, patient.igsII),
        ...igsGroups('', complete)
      ]
    },
    {
      title: 'Caractéristiques des cathéters centraux',
      key: 'kt',
      list: [
        fromField('kt_type', reaInfADI.catheterType.v3),
        fromField('kt_insertionSite', bact.insertionSite.full, 9),
        { f: 'kt_lapse', t: 'Durée de cathétérisme', minimizeDecimalScale: true },
        fromField('kt_removed', catheter.removed, 9),
        fromField('kt_laboratory', catheter.labo.v2, 9),
        fromField('kt_isColIlcBlc', reaInfADI.isColIlcBlc, 9),
        {
          f: 'kt_covidStatus', t: 'Colonisations, ILC et BLC', h: true
        },
        fromField(`kt_covidStatus`, multi.covidStatus.std, 9),
        {
          f: 'kt_lipids', t: 'Colonisations, ILC et BLC associées à un CVC, une CCI, un PICC ou MIDline avec prolongateur (C1, C2, C4 et C8)', h: true
        },
        fromField('kt_lipids', bact.lipids.v3, 9),
        {
          f: 'kt_origin', t: 'Pour les BLC', h: true
        },
        {
          f: `kt_origin`,
          t: 'Origine',
          v: bact.bactOrigin.v2.config.values
        },
        fromField('kt_divDiag', bact.divDiag.v2, 9),
        {
          f: 'kt_clinicalSigns',
          t: 'Pour les BLC avec critère BLC 5',
          h: true
        },
        fromField('kt_clinicalSigns', bact.clinicalSigns, 9),
        fromField('kt_bioSigns', bact.bioSigns, 9),
        fromField('kt_adaptedAntibio', bact.adaptedAntibio, 9),
        fromField('kt_twoHemocs', bact.twoHemocs, 9),
        {
          f: `kt_previousManip`,
          t: 'Pour les BLC associées à une CCI, un PICC ou un MIDline avec prolongateur (C2, C4 et C8)',
          h: true
        },
        fromField(`kt_previousManip`, bact.previousManip),
        fromField(`kt_previousManipType`, bact.previousManipType.v2),
        {
          f: `kt_manipEpisodLapse`,
          t: `Délai entre la date de l'épisode et la date de manipulation`,
          minimizeDecimalScale: true
        },
        ...reaInfKtDistribution('C1'),
        ...reaInfKtDistribution('C2'),
        ...reaInfKtDistribution('C4'),
        ...reaInfKtDistribution('C5'),
        ...reaInfKtDistribution('C6'),
        ...reaInfKtDistribution('C7'),
        ...reaInfKtDistribution('C8'),
        ...reaInfKtDistribution('D1')
      ]
    },
    moDistribution('kt_blc_', 'bactériémies liées aux cathéters centraux', year),
    moDistribution('kt_nblc_', 'infections hors bactériémies liées aux cathéters centraux', year),
    bactDistribution('b_', 'bactériémies hors cathéters centraux', { covid: true }),
    moDistribution('b_', 'bactériémies hors cathéters centraux', year),
    pneuDistribution(true),
    moDistribution('p_', 'pneumopathies', year)
  ]
}
